import type { BracketPrice } from './types';
import type { HttpClient } from '@/utils/HttpClient';

export const PriceService = (httpClient: HttpClient) => ({
  fetchBrackets: (article: string) => httpClient<BracketPrice[]>({ endpoint: `/prices/${article}/brackets` }),
});
